import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';
import { identifierModuleUrl } from '@angular/compiler';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-courier-mobile-payment',
  templateUrl: './courier-mobile-payment.component.html',
  styleUrls: ['./courier-mobile-payment.component.css']
})
export class CourierMobilePaymentComponent implements OnInit {

  pageName = "Checkout / Review Details";

  cartItems = []
  numberOfItems = 0
  //calculated from the commerce data service
  cartTotalBreakDown
  cartItemsSubscription;
  shoppingCartEmpty
  cartPoints = 0

  modelId = '0';
  modelData: any;
  shippingCostValue = 0
  pageReady = false;

  //payment details
  paymentTransactionId = 0;
  paymentTransactionRef = '';
  checkComplete = false

  waybillId = "0"
  quoteAmmount = "0"
  orderObj

  authKey  = ""
  apiKey = ""

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService,
    private route: ActivatedRoute
  ) { 

    $('#loader').show();
  }

  ngOnInit() {
    $('#initialise-page').trigger('click');
    $('.site-footer').hide();
    $('.item-menu-component').hide();

    // this.route.queryParamMap.subscribe((params) => {

    //   if(params['id']) {
    //     this.modelId = params['id'];
    //     this.waybillId = params['id'];
    //   } 

    //   if(params['amount']) {
    //     this.quoteAmmount = params['amount'];
    //   } 


    // });

    this.route.queryParamMap
      .subscribe((params) => {
        this.orderObj = { ...params.keys, ...params };
      }
    );

    console.log(this.orderObj)

    if(this.orderObj.params.id != undefined) {
      this.waybillId = this.orderObj.params.id+""
    }

    if(this.orderObj.params.amount != undefined) {
      this.quoteAmmount = this.orderObj.params.amount+""
    }

    if(this.orderObj.params.authkey != undefined) {
      this.authKey = this.orderObj.params.authkey+""
      localStorage.setItem('authkey', this.authKey);
    }

    if(this.orderObj.params.apikey != undefined) {
      this.apiKey = this.orderObj.params.apikey+""
      localStorage.setItem('apikey', this.apiKey);
    }


    // let cartItems = localStorage.getItem("cartItems")
    
    // if(cartItems) {
    //   this.cartItems = JSON.parse(localStorage.getItem("cartItems"))
    //   this.numberOfItems = this.cartItems.length
    // }
    // this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
    // this.cartPoints = this._ecomm.getCartEarnPoints()

    // this.cartItemsSubscription = this._ecomm.cartItemsChanged.subscribe(
    //   (data) => {

    //   }
    // );

    if(this.waybillId && parseInt(this.waybillId) > 0) {
      this.getPaymentRequest()
    }


  }

  getPaymentRequest() {
    let modelObject1 = new FormData();
    modelObject1.append('id', this.waybillId);
    modelObject1.append('amount', this.quoteAmmount);

    // let data = {
    //   "id" : this.waybillId,
    //   "amount": this.quoteAmmount
    // }

    this._data.dynamicFormPost(modelObject1, 'courier-transaction-details') 
      .pipe(first())
      .subscribe(
        data => {

          if(data['transaction'] != undefined) {
            this.paymentTransactionId = data['transaction']['id'];
            this.paymentTransactionRef = data['transaction']['model']['modelData']['systemManagedEntities']['transaction_details']['transactionReference'];
            //save transaction 
            sessionStorage.setItem('txn', this.paymentTransactionRef);
          }

          if(data['pfObject']['Order'] != undefined) {
            this.createPaymentRequest(data['pfObject']['Order'])
          }

          this.pageReady = true;
        },
        error => {},
        () => {}
      );
  }

  createPaymentRequest(paymentDetails) {
    //create a hidden form for payfast
    //submit form and redirect to payfast
    //when complete success page or failed page
    // let testPayfastArray = {
    //   merchant_id: '10013995',
    //   merchant_key: 'u16jfkygcrj6k',
    //   name_first: 'Brian',
    //   name_last: 'Test',
    //   email_address: 'bsnyatsiner@gmail.com',
    //   cell_number: '0735211079',
    //   m_payment_id: 'refNumber',
    //   amount: 1700,
    //   item_name: 'simba test',
    //   signature: 'ff1c30e3484efa04c121d9ad22af8709'
    // }
    $('#loader').show();

    let txnPayfastArray = {
      merchant_id: paymentDetails['merchant_id'],
      merchant_key: paymentDetails['merchant_key'],
      // return_url: paymentDetails['return_url'],
      // cancel_url: paymentDetails['cancel_url'],
      notify_url: paymentDetails['notify_url'],
      name_first: paymentDetails['name_first'],
      name_last: paymentDetails['name_last'],
      email_address: paymentDetails['email_address'],
      cell_number: paymentDetails['cell_number'],
      m_payment_id: paymentDetails['m_payment_id'],
      amount: paymentDetails['amount'],
      item_name: paymentDetails['item_name'],
      signature: paymentDetails['signature']
    }

    for (const [key, value] of Object.entries(txnPayfastArray)) {
        console.log(key, value);

        $("<input>").attr({ 
          name: key, 
          id: key, 
          type: "hidden", 
          value: value 
      }).appendTo("#payfastform");


    }

    let formContent = $("#setForm").contents()

    $('#pf').contents().find('body').append(formContent);
    $('#pf').contents().find('form').submit();
    // $("#payfastform").submit();

    $('#mainReview').hide();
    $('#showPayment').show();

    // this.trackPaymentStatus()

    setTimeout(function(){
      $('#loader').hide();
    },1200);

       

  }

  trackPaymentStatus() {

    if(this.checkComplete == false) {
      let queryData = new FormData();
      queryData.append('modelName', 'PaymentTransaction');
      queryData.append('transaction_details->transactionReference->systemManagedEntities', this.paymentTransactionRef);
  
        // $('#loader').show();
        //lets get the model for this page
        this._data.getModelData(queryData) 
        .pipe(first())
        .subscribe(
          data => {
  
            let status = data['covers'][0]['cover']['model']['modelData']['systemManagedEntities']['paymentDetails']['status'];
            if(status == "COMPLETE") {
              this.checkComplete = true
              this.router.navigate(['/shop/checkout/complete']);
            }
  
            if(status == "FAILED") {
              this.checkComplete = true
              this.router.navigate(['/shop/checkout/failure']);
            }
  
            else {
              console.log('status not yet ready')
                    setTimeout(()=>{    //<<<---    using ()=> syntax
                      this.trackPaymentStatus();
                }, 6000);
        
              
            }
            
          },
          error => {
  
              // $('#loader').hide();
  
          },
  
          () => {
            // $('#loader').hide();
            // this.reviewOrderSummary()
          }
        );
    }

  }

}
